function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _JSXStyle from "styled-jsx/style";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import addWeeks from 'date-fns/add_weeks';
import eachDay from 'date-fns/each_day';
import endOfWeek from 'date-fns/end_of_week';
import format from 'date-fns/format';
import isFuture from 'date-fns/is_future';
import isPast from 'date-fns/is_past';
import isSameDay from 'date-fns/is_same_day';
import isSameMonth from 'date-fns/is_same_month';
import isToday from 'date-fns/is_today';
import startOfDay from 'date-fns/start_of_day';
import startOfMonth from 'date-fns/start_of_month';
import startOfWeek from 'date-fns/start_of_week';
import enLocale from 'date-fns/locale/en';
import Table from "./Table";

var Day = function Day(_ref) {
  var day = _ref.day,
      dateFormat = _ref.dateFormat,
      locale = _ref.locale,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["day", "dateFormat", "locale", "onClick"]);

  var disabled = !day.enabled;
  var classNames = classnames('text-center', {
    'bg-light text-muted': !day.sameMonth
  }, // Lighten days in months before & after
  {
    'bg-primary text-white': day.selected
  }, // Highlight selected date
  {
    'text-primary font-weight-bold': !day.selected && isToday(day.date)
  }, // Highlight today's date
  {
    invisible: !day.visible
  } // If date is (optionally) filtered out
  );
  var styles = disabled ? {
    cursor: 'not-allowed'
  } : {};
  var dayString = format(day.date, dateFormat, {
    locale: locale
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("td", _extends({
      onClick: disabled ? undefined : onClick // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
      ,
      role: "button",
      style: styles
    }, props, {
      className: "jsx-127732173" + " " + (props && props.className != null && props.className || classNames || "")
    }), disabled ?
    /*#__PURE__*/
    React.createElement("s", {
      className: "jsx-127732173"
    }, dayString) : dayString,
    /*#__PURE__*/
    React.createElement(_JSXStyle, {
      id: "127732173"
    }, "td.jsx-127732173:hover{font-weight:bold;}"))
  );
};

Day.displayName = "Day";
Day.propTypes = {
  day: PropTypes.shape({
    enabled: PropTypes.bool,
    sameMonth: PropTypes.bool,
    selected: PropTypes.bool,
    date: PropTypes.instanceOf(Date),
    visible: PropTypes.bool
  }),
  dateFormat: PropTypes.string,
  locale: PropTypes.object,
  onClick: PropTypes.func
};

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  function Calendar() {
    _classCallCheck(this, Calendar);

    return _super.apply(this, arguments);
  }

  _createClass(Calendar, [{
    key: "visibleDays",
    // TODO extract as module to share or test easier?:
    value: function visibleDays(currentDate) {
      var _this = this;

      var start = startOfWeek(startOfMonth(currentDate));
      var end = endOfWeek(addWeeks(start, 5)); // Generate calendar days:

      return eachDay(start, end).map(function (date) {
        return {
          selected: isSameDay(currentDate, date),
          date: startOfDay(date),
          enabled: _this.props.dateEnabled(date),
          visible: _this.props.dateVisible(date),
          past: isPast(date),
          today: isToday(date),
          sameMonth: isSameMonth(currentDate, date),
          future: isFuture(date)
        };
      });
    }
  }, {
    key: "visibleWeeks",
    value: function visibleWeeks(currentDate) {
      var days = this.visibleDays(currentDate); // Chunk into list of weeks:

      var weeks = [];

      for (var i = 0, len = days.length; i < len; i += 7) {
        weeks.push(days.slice(i, i + 7));
      }

      return weeks;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          date = _this$props.date,
          dateFormat = _this$props.dateFormat,
          locale = _this$props.locale,
          onSelect = _this$props.onSelect,
          renderDay = _this$props.renderDay,
          weekDayFormat = _this$props.weekDayFormat,
          props = _objectWithoutProperties(_this$props, ["date", "dateFormat", "locale", "onSelect", "renderDay", "weekDayFormat"]);

      var weeks = this.visibleWeeks(date);
      delete props.dateEnabled; // Table doesn't need dateVisible

      delete props.dateVisible; // Table doesn't need dateVisible

      return (
        /*#__PURE__*/
        React.createElement(Table, _extends({
          bordered: false,
          hover: false,
          striped: false
        }, props),
        /*#__PURE__*/
        React.createElement("colgroup", null,
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        }),
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        }),
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        }),
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        }),
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        }),
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        }),
        /*#__PURE__*/
        React.createElement("col", {
          style: {
            width: '14.29%'
          }
        })),
        /*#__PURE__*/
        React.createElement("thead", null,
        /*#__PURE__*/
        React.createElement("tr", {
          className: "js-calendar-weekdays"
        }, weeks[0].map(function (day, i) {
          return (
            /*#__PURE__*/
            React.createElement("th", {
              key: i,
              className: "text-center"
            }, format(day.date, weekDayFormat, {
              locale: locale
            }))
          );
        }))),
        /*#__PURE__*/
        React.createElement("tbody", null, weeks.map(function (days, w) {
          return (
            /*#__PURE__*/
            React.createElement("tr", {
              key: w
            }, days.map(function (day) {
              return renderDay(day, dateFormat, onSelect, locale);
            }))
          );
        })))
      );
    }
  }]);

  return Calendar;
}(React.Component);

Calendar.propTypes = {
  className: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  dateFormat: PropTypes.string,
  dateEnabled: PropTypes.func,
  dateVisible: PropTypes.func,
  locale: PropTypes.object,
  onSelect: PropTypes.func,
  renderDay: PropTypes.func,
  weekDayFormat: PropTypes.string
};
Calendar.defaultProps = {
  className: '',
  date: new Date(),
  dateFormat: 'D',
  dateEnabled: function dateEnabled() {
    return true;
  },
  dateVisible: function dateVisible() {
    return true;
  },
  locale: enLocale,
  renderDay: function renderDay(day, dateFormat, onSelect, locale) {
    return (
      /*#__PURE__*/
      React.createElement(Day, {
        day: day,
        dateFormat: dateFormat,
        key: day.date.toString(),
        locale: locale,
        onClick: function onClick() {
          return day.visible && onSelect(day.date);
        }
      })
    );
  },
  weekDayFormat: 'dd',
  onSelect: function onSelect() {}
};
Calendar.displayName = "Calendar";
export default Calendar;